import { Modal } from 'antd';
import type { ImportEntity } from '@/services/import.service';
import { ImportWizard } from '@/pages/Import';

interface ImportWizardModalProps {
    entity: ImportEntity;
    open: boolean;
    onClose: () => void;
}

const ENTITY_TITLE: Record<ImportEntity, string> = {
    products: 'Import sản phẩm',
    customers: 'Import khách hàng',
    suppliers: 'Import nhà cung cấp',
};

export function ImportWizardModal({ entity, open, onClose }: ImportWizardModalProps) {
    return (
        <Modal
            title={ENTITY_TITLE[entity]}
            open={open}
            onCancel={onClose}
            footer={null}
            destroyOnHidden
            width={1040}
            styles={{ body: { overflowY: 'auto' } }}
        >
            <ImportWizard entity={entity} embedded onClose={onClose} />
        </Modal>
    );
}
